<template>
    <v-row
        v-if="userSetupFinished"
        no-gutters
        class="fill-height"
        align="start"
        :class="isMiniUku && $vuetify.breakpoint.height > 200 ? 'mx-3' : ''"
    >
        <AppNavigationDrawer
            v-if="$vuetify.breakpoint.mdAndUp"
            v-show="!wizard_mode"
            :drawer.sync="drawer"
            @sticky="isMenuSticky = $event"
        />
        <v-col v-if="$vuetify.breakpoint.height > 200" cols="12">
            <AppToolbar
                v-show="!wizard_mode && !isMobileDialog"
                :calendar.sync="isCalendarOpen"
                :drawer.sync="drawer"
                :is-mini-uku="isMiniUku"
                :is-mobile="$vuetify.breakpoint.smAndDown"
            />
        </v-col>
        <LoaderPopup/>
        <v-content
            v-if="$vuetify.breakpoint.height > 200"
            class="pageContent hideOnMiniUkuClose"
            :class="[
                'fill-height',
                isMobileDialog ? 'mobile-dialog' : '',
                isMiniUku ? 'elevation-3' : '',
                isMiniUku && noFooter ? 'no-footer' : '',
                isMenuSticky ? 'menu-sticky' : ''
            ]"
            :style="{
                paddingLeft: paddingLeft,
                paddingTop: isMobileDialog || isMiniUku || wizard_mode ? '0' : '56px',
                paddingBottom: $vuetify.breakpoint.smAndDown && !isMobileDialog && !isMiniUku ? '100px' : '',
                backgroundColor: $vuetify.breakpoint.smAndDown && !isMobileDialog ? 'white' : '',
                paddingRight: isSidebarVisible && isSidebarOpen && $vuetify.breakpoint.mdAndUp ? '382px' : null
            }"
        >
            <div class="d-flex flex-column" style="height: 100%;">
                <div class="d-flex flex-grow-1">
                    <router-view
                        v-if="router_key"
                        ref="router_view"
                        :class="[
                            isMobileDialog ? 'pa-0' : '',
                            isMiniUku && $route.name !== 'task' ? 'miniUkuContent' : ''
                        ]"
                    />
                    <Sidebar
                        v-if="isSidebarVisible"
                        :related-type="$route.meta.sidebar.relatedType"
                        :sub-type="$route.meta.sidebar.subType"
                        :is-sidebar-open="isSidebarOpen"
                    />
                </div>
            </div>

            <TaskDialog
                :show-dialog="task_dialog_show"
                :task-id="taskDialog.task_id"
                :client-id="taskDialog.client_id"
                :title="taskDialog.title"
                :topic-id="taskDialog.topic_id"
                :project-id="taskDialog.project_id"
                :date="taskDialog.date"
                :is-template="taskDialog.is_template"
                :is-task-button="taskDialog.is_task_button"
                :company-id="taskDialog.company_id"
                :time-entry="taskDialog.timeEntry"
            />
            <Dialog/>
            <FeatureNotEnabledDialog/>
            <ErrorDialog2/>
            <ConfirmDialog/>
            <ErrorDialog/>
            <SnackBar/>
            <TrialEndSnackBar/>
            <FeedbackNotification/>
        </v-content>
        <AppBottomNavigation
            v-if="$vuetify.breakpoint.smAndDown && !isMobileDialog && $vuetify.breakpoint.height > 200"
            v-show="!wizard_mode"
            :drawer.sync="drawer"
            :is-mini-uku="isMiniUku"
        />

        <Miniuku v-if="isMiniUku"/>
        <ImportDoneModal/>
    </v-row>
</template>

<script>
import AppNavigationDrawer from "./components/AppNavigationDrawer";
import AppBottomNavigation from "./components/AppBottomNavigation";
import Sidebar from "./components/Sidebar";
import AppToolbar from "./views/AppToolbar/";
import Dialog from "./views/Dialog";
import SnackBar from "./components/SnackBar";
import ConfirmDialog from "./views/ConfirmDialog";
import ErrorDialog from "./views/ErrorDialog";
import ErrorDialog2 from "./views/ErrorDialog/index2";
import FeatureNotEnabledDialog from "./components/Dialog/FeatureNotEnabledDialog.vue";
import {Router} from "./composables/Router";
import AppModule from "./store/modules/app";
import TaskModule from "./store/modules/task";
import AccountModule from "./store/modules/account";
import {ref, watch, computed, onBeforeMount} from "@vue/composition-api";
import TaskDialog from "./views/Task/TaskDialog";
import Calendar from "./views/Calendar/Calendar";
import Miniuku from "@/views/Miniuku/index";
import TimerModule from "./store/modules/timer";
import {formatTimeDuration} from "./plugins/formatting";
import TrialEndSnackBar from "@/components/TrialEndSnackBar";
import LoaderPopup from "@/components/LoaderPopup"
import NotificationModule from "@/store/modules/notification";
import BreadcrumbsModule from "@/store/modules/breadcrumbs";
import ImportDoneModal from "@/components/Dialog/ImportDoneModal/Index"
import FeedbackNotification from "@/components/FeedbackNotification";
import {isPwa} from "@/helpers/helpers";

export default {
    name: "MainVue",
    components: {
        Miniuku,
        AppNavigationDrawer,
        AppBottomNavigation,
        Sidebar,
        AppToolbar,
        Dialog,
        ConfirmDialog,
        ErrorDialog,
        SnackBar,
        ErrorDialog2,
        TaskDialog,
        Calendar,
        FeatureNotEnabledDialog,
        TrialEndSnackBar,
        LoaderPopup,
        ImportDoneModal,
        FeedbackNotification
    },
    setup(props, ctx) {
        const {sideBarOpen, miniUkuNoFooter, vueContext, isCalendarOpen, toggleCalendar, router_key} = AppModule();
        const {current_account} = AccountModule();
        const {task_dialog} = TaskModule();
        const {status, task_status, total_duration, running_duration, ticking_duration} = TimerModule();
        const {setBreadcrumbs} = BreadcrumbsModule();
        const router = Router();
        const userSetupFinished = ref(false);
        const watchTimerTicking = ref(false);
        const {fetchNotifications} = NotificationModule();

        const isSidebarOpen = computed(() => {
            return isSidebarVisible.value && (sideBarOpen.value || ctx.root._route.meta.sidebar.forceToggle)
        })

        let drawer = ref(true);
        const isMenuSticky = ref(false);

        const task_dialog_show = ref(false);

        const wizard_mode = computed(() => {
            if (ctx.root._route.meta.wizard_mode === undefined) return false;
            return ctx.root._route.meta.wizard_mode;
        });

        const footerSpacing = computed(() => {
            if (ctx.root._route.meta.footerSpacing === undefined) return true;
            return ctx.root._route.meta.footerSpacing;
        });

        vueContext.value = ctx

        const resetBreadcrumbs = () => {
            setBreadcrumbs([], "")
        }

        watch(
            () => ctx.root._route.name,
            (newVal, oldVal) => {
                resetBreadcrumbs();
                if (newVal !== oldVal) toggleCalendar(false);
            }
        );

        const isSidebarVisible = computed(() => {
            return ctx.root._route.meta.sidebar && (!ctx.root._route.meta.sidebar.hideMobile || (ctx.root._route.meta.sidebar.hideMobile && ctx.root.$vuetify.breakpoint.width > 1600))
        })

        watch([status, task_status], ([statusVal, relatedStatusVal]) => {
            if (statusVal === "stopped" && relatedStatusVal === "finished") {
                watchTimerTicking.value = false;
                let titleSuffix = "Uku"
                if (process.env.VUE_APP_BETA === "true") titleSuffix = "PRELIVE Uku"
                if (process.env.VUE_APP_TEST === "true") titleSuffix = "TEST Uku"
                document.title = titleSuffix
            } else if (statusVal === "running") {
                watchTimerTicking.value = true;
            }
        });

        watch(ticking_duration, () => {
            if (!watchTimerTicking.value) return;
            const total = total_duration.value + running_duration.value + ticking_duration.value;
            let titleSuffix = "Uku"
            if (process.env.VUE_APP_BETA === "true") titleSuffix = "PRELIVE Uku"
            if (process.env.VUE_APP_TEST === "true") titleSuffix = "TEST Uku"
            if (isPwa()) {
                document.title = `${formatTimeDuration(total, "", true)}`;
            } else {
                document.title = `${formatTimeDuration(total, "", true)} - ${titleSuffix}`;
            }
        });

        onBeforeMount(() => {
            // Hotfix for when user has exited setup flow midway and navigates to app.
            if (!current_account.value.name.length || current_account.value.data.onboarding_in_progress === 1) {
                router.replace({name: "setup_country"});
                return;
            } else {
                userSetupFinished.value = true;
            }
        });

        let route = router.currentRoute;
        const isMobileDialog = ref(route.meta.is_mobile_dialog !== undefined && route.meta.is_mobile_dialog);

        router.beforeResolve(function (to, from, next) {
            isMobileDialog.value = to.meta.is_mobile_dialog !== undefined && to.meta.is_mobile_dialog;
            next();
        });

        const paddingLeft = computed(function () {
            if (isMobileDialog.value || wizard_mode.value) return "0px";
            if (isMenuSticky.value && ctx.root.$vuetify.breakpoint.mdAndUp) return "180px";

            return ctx.root.$vuetify.breakpoint.smAndDown ? "0px" : "60px";
        });

        const showTaskDialog = computed(function () {
            if (!task_dialog.value.show) return false;
            return "{0}_{1}_{2}".format(
                task_dialog.value.show,
                task_dialog.value.task_id,
                task_dialog.value.is_template
            );
        });
        const taskDialog = computed(function () {
            return task_dialog.value;
        });
        const openTaskDialog = function () {
            task_dialog_show.value = true;
        };
        const openTaskPage = function () {
            if (taskDialog.value.task_id === 0) {
                if (taskDialog.value.client_id === 0 && !taskDialog.value.title) {
                    router.push("/tasks/0{0}".format(taskDialog.value.is_template ? "/new_task_template" : ""));
                } else if (taskDialog.value.title) {
                    // If is a new task based on checklist item (title is prefilled)
                    router.push({
                        path: "/tasks/0{0}".format(taskDialog.value.is_template ? "/new_task_template" : ""),
                        query: {
                            title: taskDialog.value.title,
                            client_id: taskDialog.value.client_id,
                            topic_id: taskDialog.value.topic_id
                        }
                    });
                } else {
                    router.push(
                        "/clients/{0}{1}".format(
                            taskDialog.value.client_id,
                            taskDialog.value.is_template ? "/new_task_template" : "/new_task"
                        )
                    );
                }
            } else {
                if (taskDialog.value.is_template) {
                    if (taskDialog.value.client_id !== 0) {
                        router.push(
                            "/clients/{0}/{1}/new_task_template".format(
                                taskDialog.value.client_id,
                                taskDialog.value.task_id
                            )
                        );
                    } else {
                        router.push("/tasks/{0}/new_task_template".format(taskDialog.value.task_id));
                    }
                    return;
                }
                if (taskDialog.value.client_id === 0) {
                    router.push("/tasks/{0}".format(taskDialog.value.task_id));
                } else {
                    router.push("/clients/{0}/tasks/{1}".format(taskDialog.value.client_id, taskDialog.value.task_id));
                }
            }
        };
        const closeTaskDialog = function () {
            task_dialog_show.value = false;
        };
        const closeTaskPage = function () {
            if (ctx.root._route.params.client_id === undefined) {
                router.push("/");
            } else {
                router.push("/clients/{0}/tasks".format(ctx.root._route.params.client_id));
            }
        };
        watch(showTaskDialog, function (current, previous) {
            if (previous === undefined) return;
            if (current) {
                if (ctx.root.$vuetify.breakpoint.smAndDown) openTaskPage();
                else openTaskDialog();
            } else {
                if (router.currentRoute.meta.is_mobile_dialog) closeTaskPage();
                else closeTaskDialog();
            }
        });
        const isMiniUku = computed(function () {
            if (ctx.root._route.query.ukuwinversion !== undefined) {
                return true;
            }
            return false;
        });
        const noFooter = computed(function () {
            if (["task", "new_client_task", "client_task"].indexOf(ctx.root._route.name) === -1) return false;
            return miniUkuNoFooter.value;
        });

        if (isMiniUku) {
            const current_route = computed(() => ctx.root._route);
            watch(current_route, function (val) {
                if (val.query.ukuwinversion !== undefined) {
                    window.parent.postMessage(
                        {
                            action: "add_current_url",
                            url: val.fullPath
                        },
                        "*"
                    );
                }
            });
        }
        fetchNotifications()
        return {
            drawer,
            isCalendarOpen,
            router_key,
            wizard_mode,
            task_dialog_show,
            taskDialog,
            isMobileDialog,
            paddingLeft,
            isMiniUku,
            noFooter,
            userSetupFinished,
            isMenuSticky,
            footerSpacing,
            isSidebarOpen,
            isSidebarVisible,
        };
    }
};
</script>

<style lang="scss" scoped>
.dashboard-calendar {
    border-bottom-left-radius: 4px;
    padding-top: 56px;
    padding-left: 64px;
    overflow: hidden;
    z-index: 3;
    max-height: 440px;
    width: auto;

    &.real-calendar {
        top: 56px;
        left: 71px;
        right: 0;
        position: fixed;
    }

    &.fake-calendar {
        height: 440px;
        width: 100%;
    }
}
</style>
